import { Routes } from '@angular/router';
import { paymentRulesRedirect } from '../../shared/payment-rules/payment-rules-redirects';
import { DESKTOP_SEARCH_MAIN_ROUTES } from './pages/search/search.routes';
import { DESKTOP_ABOUT_BENEFITS_ROUTES } from './pages/nav-pages/about-benefits/about-benefits.routes';
import { DESKTOP_ABOUT_PROJECT_ROUTES } from './pages/nav-pages/about-project/about-project.routes';
import { authGuard } from '@pkp/core';
import { companyManagerGuard } from './guards/company-manager.guard';
import { DESKTOP_MENU_ROUTES } from './pages/menu/menu.routes';
import { DESKTOP_REPLENISHMENT_REQUESTS_ROUTES } from './pages/replenishment-requests/replenishment-requests.routes';
import { DESKTOP_FEEDBACK_ROUTES } from './pages/feedback/feedback.routes';
import { residentRedirect } from '../../shared/benefits-page/benefits-redirects';

export const DESKTOP_MAIN_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./pages/search/search.page').then(c => c.SearchPageComponent),
    children: [...DESKTOP_SEARCH_MAIN_ROUTES],
  },
  {
    path: 'tariffs',
    loadComponent: () =>
      import('./pages/nav-pages/tariffs/tariffs.component').then(c => c.DesktopTariffsComponent),
  },
  // Оплата и штрафы — одна страница payment-rules (прототип 1a); старые адреса редиректят на вкладки.
  { path: 'about-payments', pathMatch: 'full', redirectTo: 'payment-rules' },
  {
    path: 'about-payments/mobile',
    pathMatch: 'full',
    redirectTo: paymentRulesRedirect('desktop', 'app'),
  },
  { path: 'about-fines', pathMatch: 'full', redirectTo: paymentRulesRedirect('desktop', 'fines') },
  {
    path: 'payment-rules',
    loadComponent: () =>
      import('./pages/nav-pages/payment-rules/payment-rules.component').then(
        c => c.DesktopPaymentRulesPageComponent,
      ),
  },
  {
    path: 'about-benefits/citizens',
    pathMatch: 'full',
    redirectTo: 'about-benefits',
  },
  {
    path: 'about-benefits/online-application',
    pathMatch: 'full',
    redirectTo: 'about-benefits',
  },
  { path: 'about-residents', pathMatch: 'full', redirectTo: residentRedirect('desktop') },
  {
    path: 'about-residents/resident-abonement',
    pathMatch: 'full',
    redirectTo: residentRedirect('desktop'),
  },
  // Льготы — одна страница about-benefits (UIMSP-1450); старые адреса хаба и категорий редиректят на неё.
  {
    path: 'about-benefits',
    loadComponent: () =>
      import('./pages/nav-pages/about-benefits/about-benefits.component').then(
        c => c.DesktopAboutBenefitsComponent,
      ),
    children: [...DESKTOP_ABOUT_BENEFITS_ROUTES],
  },
  {
    path: 'about-project',
    loadComponent: () =>
      import('./pages/nav-pages/about-project/about-project.component').then(
        c => c.DesktopAboutProjectComponent,
      ),
    children: [...DESKTOP_ABOUT_PROJECT_ROUTES],
  },
  {
    path: 'menu',
    children: [...DESKTOP_MENU_ROUTES],
  },
  {
    path: 'faq',
    loadComponent: () =>
      import('./pages/nav-pages/faq/faq.component').then(c => c.DesktopFAQComponent),
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/settings/settings-page.component').then(c => c.DesktopSettingsPageComponent),
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then(c => c.ProfilePageComponent),
  },
  {
    path: 'feedback',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/feedback/feedback-page.component').then(c => c.DesktopFeedbackPageComponent),
    children: [...DESKTOP_FEEDBACK_ROUTES],
  },
  {
    path: 'balance-history',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/balance-history/balance-history.component').then(
        c => c.DesktopBalanceHistoryPageComponent,
      ),
  },
  {
    path: 'employees',
    canActivate: [authGuard, companyManagerGuard],
    loadComponent: () =>
      import('./pages/employees-page/employees-page.component').then(
        c => c.DesktopEmployeesPageComponent,
      ),
  },
  {
    path: 'replenishment-requests',
    loadComponent: () =>
      import('./pages/replenishment-requests/replenishment-requests.component').then(
        c => c.DesktopReplenishmentRequestsPageComponent,
      ),
    children: [...DESKTOP_REPLENISHMENT_REQUESTS_ROUTES],
  },
  {
    path: 'sessions',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/sessions/sessions-page.component').then(c => c.DesktopSessionsPageComponent),
  },
  {
    path: 'vehicles',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/vehicles/vehicles-page.component').then(c => c.DesktopVehiclesPageComponent),
  },
  {
    path: 'payment-cards',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/payment-cards/payment-cards-page.component').then(
        c => c.DesktopPaymentCardsPageComponent,
      ),
  },
  {
    path: 'subscriptions',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/subscriptions/subscriptions.page').then(
        c => c.DesktopSubscriptionsPageComponent,
      ),
  },
];
